<template>
    <HeaderList>
        <template #content>
            <h1 class="name">{{ $t('views.users.title') }}</h1>
            <p>{{ $t('views.users.description', { accountName: accountStore.account.name }) }}</p>
        </template>
        <template #actions>
            <UserCreate />
        </template>
    </HeaderList>
</template>

<script>
    import HeaderList from '@/components/sections/HeaderList';
    import UserCreate from '@/components/users/UserCreate';
    import { useAccountStore } from '@/stores/account';

    export default {
        name: "UserHeader",
        components: {
            HeaderList,
            UserCreate
        },
        computed: {
            accountStore() {
                return useAccountStore();
            }
        }
    }
</script>
